<script setup lang="ts">
    import Sidebar from '../components/Sidebar.vue'
    import MobileFooterbar from '../components/mobile/MobileFooterbar.vue'
    import DetectScreenSize from '../components/misc/DetectScreenSize.vue'
    import MobileSearchField from '../components/mobile/SearchField.vue'
    import RodapeComponent from '../components/desktop/RodapeComponent.vue'

</script>

<template><detect-screen-size @onScreenSizeChanged="changeLayout" />
<detect-p-w-a />
<div id="global-default-layout-container" class="overflow-hidden">
    <div v-if="isMobile">
        <Transition name="slide-fade">
            <div class="row">
                <div class="col-12">
                    <mobile-search-field />
                    <main id="main-mobile-layout" class="flex-shrink-0">
                        <slot></slot>
                    </main>
                    <mobile-footerbar />
                </div>
            </div>
        </Transition>
    </div>
    <div v-else>
        <Transition name="slide-fade">
            <div class="row">
                <div class="col-12">
                    <sidebar />
                    <main id="main-layout">
                        <slot></slot>
                    </main>
                    <rodape-component />
                </div>
            </div>
        </Transition>
    </div>
</div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { useLayoutStore } from '@/stores/layout';

    export default defineComponent({
        name: "DefaultLayout",
        data() {
            return {
                isMobile: false,
            };
        },
        mounted() {
            // console.log('default layout mounted');
        },
        methods: {
            changeLayout(isMobile: boolean): void {
                this.isMobile = isMobile;
                const layout = useLayoutStore();
                let bottomMargin = isMobile ? 75 : 50; // 70px rodapé <mobile-footerbar /> / 50px rodapé <rodape-component />
                layout.setMarginBottomValue(bottomMargin);

                const [actual, next]: [string, string] = [(this.isMobile ? '/desktop' : '/mobile'), (this.isMobile ? '/mobile' : '/desktop')];

                if (this.$route.path.includes(actual)) {
                    this.$router.push(this.$route.path.replace(actual, next));
                }
            },
        },
    });
</script>